import styled from "styled-components";
import { Person, Email, Phone } from "../../assets/Icons";

function Contact() {
  return (
    <Root>
      <h2 id="contact">KONTAKTA OSS</h2>
      <StyledContactArea>
        <div></div>
        <StyledSlogan>
          <p>
            "Utbildningar för bygg, anläggning och industri
            <br />- Vi rustar dig för säkerhet, oavsett var du är!""
          </p>
        </StyledSlogan>

        <StyledContactDetails>
          <p style={{ margin: "20px 0 10px 0" }}>
            <StyledA>
              <span style={{ verticalAlign: "middle" }}>
                <Person />
              </span>{" "}
              Säljare/Samordnare Lotta von Braun
            </StyledA>
          </p>

          <StyledP>
            <StyledA href="tel:+46739519360">
              <span style={{ verticalAlign: "middle" }}>
                <Phone />
              </span>{" "}
              +46 073-951 93 60
            </StyledA>
          </StyledP>

          <StyledP>
            <StyledA href="mailto:lotta@vonbraunutbildning.se">
              <span style={{ verticalAlign: "middle" }}>
                <Email />
              </span>{" "}
              lotta@vonbraunutbildning.se
            </StyledA>
          </StyledP>
        </StyledContactDetails>
      </StyledContactArea>
    </Root>
  );
}
export default Contact;

const Root = styled.div`
  padding: var(--main-padding);
`;

const StyledContactArea = styled.div`
  display: grid;
  grid-template-columns: 30% 20% 50%;

  @media screen and (max-width: 950px) {
    grid-template-columns: 1fr;
  }
`;

const StyledSlogan = styled.div`
  padding-right: 30px;
  text-align: justify;
  line-height: 190%;
  font-size: medium;
  display: flex;
  align-items: center;
`;

const StyledContactDetails = styled.div`
  padding-left: 30px;
  border-left: solid black 0.25px;
  font-size: medium;
  line-height: 190%;

  @media screen and (max-width: 950px) {
    border-left: none;
    padding-left: 0;
  }
`;

const StyledA = styled.a`
  text-decoration: none;
  color: black;
`;

const StyledP = styled.p`
  margin: 10px 0;

  :hover {
    transform: scale(1.06) translate(2%);
    cursor: pointer;
    ${StyledA} {
      color: var(--focus-clr);
    }
  }
`;
